export default "__VITE_ASSET__JpXY5950__"